// The API stores the SSR UserSplit as a 0–1 fraction (deviceapi application_user_split; see
// create_client_application.go validateSSR). Padmin shows and accepts it as a 0–100 percentage.
// Both the Create Application form and the Application Management SSR editor convert through
// these helpers so the two can't drift.

// Converts a User Split % input to the fraction sent to the API, or null if it isn't a number.
// toFixed(8) guards against float artefacts (e.g. 29.7 / 100 === 0.29700000000000004).
export const toUserSplitFraction = (percent: string): number | null => {
  const value = Number(percent);
  if (percent.trim() === '' || !Number.isFinite(value)) return null;
  return Number((value / 100).toFixed(8));
};

// Converts a stored fraction back to the percentage shown in the input ('' when unset).
// toFixed(6) guards against float artefacts like 0.07 * 100 === 7.000000000000001.
export const toUserSplitPercent = (fraction?: number | null): string =>
  fraction != null ? String(Number((fraction * 100).toFixed(6))) : '';

// deviceapi stores the split as NUMERIC(10,2) and ValidateUserSplit rejects more than 2 decimal places, so
// only whole percentages from 1 to 100 can be saved (0.4% would be 0.004).
export const isValidUserSplitPercent = (percent: string): boolean => {
  const value = Number(percent);
  return percent.trim() !== '' && Number.isInteger(value) && value >= 1 && value <= 100;
};

export const USER_SPLIT_ERROR = 'Enter a whole number from 1 to 100';
